<div class="card-login card-outline">
    <div class="card-header text-center">
        <p  class="h1">Instituto <b>IFAM</b></p>
        <p>Profesores</p>
    </div>    
    <div class="card-body">
        <p class="login-box-msg">Ingresa tus credenciales</p>

        <form [formGroup]="loginForm" (ngSubmit)="loginByAuth()">
            <div class="input-group mb-3">
                <input
                    formControlName="email"
                    type="email"
                    class="form-control"
                    placeholder="Usuario"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-envelope"></span>
                    </div>
                </div>
            </div>
            <div class="input-group mb-3">
                <input
                    formControlName="password"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-lock"></span>
                    </div>
                </div>
            </div>
            <div class="row">

                <!-- /.col -->
                <div class="col-5">
                    <div class="width: 100%;">
                    <pf-button style="display: block; margin: 0 auto;"
                        [type]="'submit'"
                        [block]="true"
                        [loading]="isAuthLoading"
                        [disabled]="isFacebookLoading || isGoogleLoading" >
                        Ingresar
                    </pf-button>
                </div>
                </div>

                <!-- /.col -->
            </div>
        </form>
   
    </div>
    <!-- /.login-card-body -->
</div>
